/**
 * Detect the file type from a URL string (ignores query params / fragments).
 *
 * @param {string} url
 * @returns {'pdf' | 'image' | 'other'}
 */
export function getFileType(url) {
  const clean = (url ?? '').split('?')[0].split('#')[0]
  const ext = clean.split('.').pop()?.toLowerCase() ?? ''
  if (ext === 'pdf') return 'pdf'
  if (['jpg', 'jpeg', 'png', 'webp', 'gif', 'svg'].includes(ext)) return 'image'
  return 'other'
}
